<template>
  <ManagerLayout class="home">
    <header class="home-header">
      <span class="home-header__brand">启明服务管理平台</span>
      <nav class="home-header__nav" aria-label="主导航">
        <router-link class="nav-link" exact-active-class="nav-active" to="/">首页</router-link>
        <router-link class="nav-link" active-class="nav-active" to="/wechat-followers">微信用户</router-link>
        <router-link v-if="employee" class="nav-link" active-class="nav-active" to="/feedback">患者反馈</router-link>
        <button v-if="employee" type="button" class="nav-action" @click="handleLogout">退出登录</button>
        <router-link v-else class="nav-action" to="/login">登录</router-link>
      </nav>
    </header>

    <div class="intro-wrap">
      <div class="intro">
        <div class="logo">
          <i class="fas fa-eye"></i>
          <h1>滕州启明眼科医院</h1>
        </div>
        <p class="slogan">一切以患者为中心 · 以医疗质量为核心</p>

        <p class="desc">
          滕州启明眼科医院是枣庄地区按三级标准建设的专业眼科医院，是枣庄市医保定点医院，是视力残疾精准康复指导站，是“慈善光明行动”定点医院，是中小学近视防控基地。医院全套引进世界同步的眼科检查、治疗设备，引进国内高水平眼科专业人才，特邀国内知名眼科专家定期来院坐诊、手术。医院设有屈光专科、白内障科、眼底科、青光眼科、小儿眼科、干眼科、视光中心等科室，医院开放床位50张。医院秉承“一切以患者为中心，以医疗质量为核心”的服务理念，竭诚为广大眼病患者服务。
        </p>

        <div class="contact">
          <i class="fas fa-phone-alt"></i>
          <span>咨询电话：0632-3596666 / 15336325533</span>
        </div>
      </div>
    </div>
  </ManagerLayout>
</template>

<script>
import { isNavigationFailure } from 'vue-router'
import { state, logout } from '@/store/session'
import ManagerLayout from '@/components/ManagerLayout.vue'

// 首页 - 医院介绍
export default {
  name: 'HomeIndex',
  components: { ManagerLayout },
  computed: {
    employee () {
      return state.employee
    }
  },
  methods: {
    async handleLogout () {
      await logout()
      if (this.$route.name === 'login') return
      try {
        await this.$router.replace({ name: 'login' })
      } catch (error) {
        if (!isNavigationFailure(error)) window.location.hash = '#/login'
      }
    }
  }
}
</script>

<style scoped>
.home-header {
  display: none;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 18px 28px;
}

.home-header__brand {
  color: #173b46;
  font-size: 15px;
  font-weight: 700;
  white-space: nowrap;
}

.home-header__nav {
  display: flex;
  align-items: center;
  gap: 24px;
  min-width: 0;
}

.nav-link {
  color: #5c7376;
  font-size: 13px;
  text-decoration: none;
  white-space: nowrap;
}

.nav-link:hover,
.nav-active {
  color: #237d72;
  font-weight: 600;
}

.nav-action {
  padding: 0;
  border: 0;
  color: #557075;
  background: transparent;
  cursor: pointer;
  font: inherit;
  font-size: 13px;
  text-decoration: none;
  white-space: nowrap;
}

.nav-action:hover {
  color: #168976;
}

.intro-wrap {
  flex: 1;
  display: grid;
  place-items: center;
  padding: 24px 24px 56px;
}

.intro {
  max-width: 720px;
  text-align: center;
}

.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 16px;
}

.logo i {
  font-size: 2.8rem;
  color: #12b0b0;
}

.logo h1 {
  font-size: 2.2rem;
  font-weight: 700;
  color: #0b6e9c;
  letter-spacing: -0.5px;
}

.slogan {
  font-size: 1.1rem;
  font-weight: 600;
  color: #12b0b0;
  margin-bottom: 28px;
  letter-spacing: 1px;
}

.desc {
  font-size: 1.05rem;
  line-height: 2;
  color: #4a6b7c;
  text-align: justify;
  margin-bottom: 32px;
}

.contact {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 1.05rem;
  font-weight: 600;
  color: #0b6e9c;
  background: #e4f2f9;
  padding: 12px 28px;
  border-radius: 60px;
}

.contact i {
  color: #12b0b0;
}

@media (max-width: 900px) {
  .home { background: linear-gradient(135deg, #eef8fc 0%, #ffffff 100%); }
  .home-header { display: flex; }
}
@media (max-width: 640px) {
  .home-header { padding: 14px 18px; }
  .home-header__nav { gap: 16px; }
  .intro-wrap { padding: 18px 20px 44px; }
  .logo h1 {
    font-size: 1.6rem;
  }
  .logo i {
    font-size: 2rem;
  }
  .desc {
    font-size: 0.95rem;
    text-align: left;
  }
  .contact {
    font-size: 0.9rem;
    padding: 10px 20px;
    flex-direction: column;
    gap: 4px;
  }
}
</style>
